import { create } from 'zustand';
import { LogErrorFcn } from '../types';

interface ErrorLoggerStore {
    logError: LogErrorFcn | null;
    setLogError: (logger: LogErrorFcn) => void;
}

export const useErrorLoggerStore = create<ErrorLoggerStore>((set) => ({
    logError: null,
    setLogError: (logger) => set({ logError: logger }),
}));

// Non-hook version for use in utility functions
export const getErrorLogger = () => {
    const logger = useErrorLoggerStore.getState().logError;
    if (!logger) {
        // Fallback to console.error if no logger is configured
        return (error: unknown, context?: Record<string, unknown>) => {
            console.error(error, context);
        };
    }
    return logger;
};
